import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { concatMap, take, tap } from 'rxjs/operators';
import { AccountUsage } from '../../../../models/account-usage.model';
import { Account } from '../../../../models/ui/account.model';
import { AccountAdminService } from '../../../../services/account-admin.service';
import { HelpService } from '../../../../services/help.service';
import { ExportSdk } from '../../../../sdks/export.sdk';

@Component({
    selector: 'lex-manage-billing-list',
    templateUrl: './manage-billing-list.component.html',
    styleUrls: ['./manage-billing-list.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})

export class ManageBillingListComponent implements OnInit {

	public selectedAccount: Account = null;
	public selectedAccountId: string = null;

	public accountUsage: AccountUsage[] = [];
	public caseUsage: AccountUsage[] = [];
	public summaryColumns = ['month', 'empty', 'documents', 'productions', 'briefcases', 'archives', 'searchIndex', 'total'];
	public detailColumns = ['details'];
	public expandedElement: AccountUsage[] = [];

	public hideCurrentMonth: boolean = true;

	constructor(
		private accountAdminService: AccountAdminService,
		private helpService: HelpService,
		private activatedRoute: ActivatedRoute,
		private exportSdk: ExportSdk) {
	}

	ngOnInit(): void {
		this.helpService.updateHelpLink('account-menu/manage-billing');
		this.activatedRoute.queryParams.pipe(take(1)).subscribe(
			param => {
				if (param['accountId']) {
					this.selectedAccountId = param['accountId'];
				}
			});
	}

	public exportToExcel(): void {
		this.exportSdk.exportUsages(this.selectedAccount.accountId).subscribe((url) => {
			window.open(url, '_blank');
		});
	}

	public selectAccount(): void {
		this.expandedElement = [];

		if (this.selectedAccount) {
			this.refreshUsage();
		}
		else {
			this.accountUsage = [];
			this.caseUsage = [];
		}
	}

	public setExpandElement(element: AccountUsage): void {
		const index = this.expandedElement.indexOf(element)
		if (index >= 0) {
			this.expandedElement.splice(index, 1);
		}
		else {
			this.expandedElement.push(element);
		}
	}

	public toggleCurrentMonth(): void {
		this.hideCurrentMonth = !this.hideCurrentMonth;
		this.refreshUsage();
	}

	private refreshUsage(): void {
		this.accountAdminService.getMonthlyAccountUsage(this.selectedAccount.accountId, !this.hideCurrentMonth).pipe(
			tap(data => {
				this.accountUsage = data;
			}),
			concatMap(() => this.accountAdminService.getMonthlyCaseUsage(this.selectedAccount.accountId, !this.hideCurrentMonth))
		).subscribe(data => {
			this.caseUsage = data;
		});
	}
}
